import { get } from '../utils/axios'

export const getProbationsAPI = async () => {
  return await get('probations/types')
}
